import { CoreUiException } from "./core-ui-exception";

export class RecordModifiedException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("RecordModifiedException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, RecordModifiedException.prototype);
    }
}
